import { render, staticRenderFns } from "./StockKDJView.vue?vue&type=template&id=5fa31460&scoped=true"
import script from "./StockKDJView.vue?vue&type=script&lang=js"
export * from "./StockKDJView.vue?vue&type=script&lang=js"
import style0 from "./StockKDJView.vue?vue&type=style&index=0&id=5fa31460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa31460",
  null
  
)

export default component.exports